/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  height: 100%;
`;

export const LeftPane = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;

  > *:not(:last-child) {
    border-bottom: 1px solid var(--cds-border-subtle-01);
  }
`;

export const Splitter = styled.div`
  width: 9px;
  margin: 0 -4px;
  position: relative;
  cursor: ew-resize;
  flex-shrink: 0;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 4px;
    width: 1px;
    background-color: var(--cds-border-subtle-01);
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 3px;
    width: 3px;
    background-color: var(--cm-color-blue-base);
    border-radius: 3px;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }

  &:hover::after,
  body.is-resizing-horizontally &::after {
    opacity: 1;
  }
`;

export const RightPane = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex-shrink: 0;

  > *:not(:last-child) {
    border-bottom: 1px solid var(--cds-border-subtle-01);
  }
`;
